<template>
  <div class="recommend">
    <div class="title">热门推荐</div>
    <ul class="range">
      <li v-for="item in info_list" :key="item.id">
        <a
          class="range-item"
          :href="item.courseDetailUrl"
          target="_blank"
          v-spm="'1003.2449.3001.7925'"
        >
          <img class="block" :src="item.courseImages" alt />
          <div class="contentx">
            <span class="des module-click">{{item.courseTitle}}</span>
            <p class="classes">共{{item.courseLessonCnt}}节 · {{item.courseViewsCnt}}人学习</p>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { getRecommendList } from "@/utils/api";

export default {
  data() {
    return {
      info_list: [],
    };
  },
  mounted() {
    getRecommendList().then((response) => {
      this.info_list = response.data.hotCourseRecommendList;
    });
  },
};
</script>

<style lang="less" scoped>
.recommend {
  width: 100%;
  background: #fff;
  border-radius: 2px;

  .title {
    padding: 8px 24px;
    font-size: 18px;
    font-weight: bold;
    color: #222226;
    line-height: 32px;
  }

  .range {
    padding: 24px;
    height: 328px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #f0f0f2;
    list-style: none;
    border-radius: 0px 0px 2px 2px;
    &-item {
      display: block;
      display: flex;
      justify-content: space-between;
    }
    li {
      width: 100%;

      .block {
        width: 64px;
        height: 64px;
        border-radius: 2px;
        object-fit: cover;
      }

      .contentx {
        width: 218px;

        .des {
          margin-bottom: 8px;
          font-size: 12px;
          font-weight: 400;
          color: #999aaa;
          line-height: 20px;
          white-space: normal;
        }

        .classes {
          font-size: 12px;
          font-weight: 400;
          color: #555666;
          line-height: 16px;
        }
      }
    }
  }
}
</style>